import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import HighlightedText from './HighlightedText.jsx';
import styles from './AutocompleteSearchBox.scss';

class AutocompleteHeader extends React.Component {
  render() {
    let {
      onClick,
      focused,
      onMouseEnter,
      onMouseLeave,
      className,
      searchTerm,
      suggestion,
      ...rest
    } = this.props;

    return (
      <h5
        className={classnames(className)}
        {...rest}
      >
        <hr />
        {suggestion}
      </h5>
    );
  }
}

AutocompleteHeader.propTypes = {
  onClick: PropTypes.func,
  focused: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  className: PropTypes.string
};

export default AutocompleteHeader;